// PEZZ web app's Firebase configuration
export const firebaseConfig = {
  apiKey: "AIzaSyC2b19U5JyxdO70-pNqJ4SP0Da3J5sj3d0",
  authDomain: "pezz-live.firebaseapp.com",
  databaseURL: "https://pezz-live.firebaseio.com",
  projectId: "pezz-live",
  storageBucket: "pezz-live.appspot.com",
  messagingSenderId: "391823697357",
  appId: "1:391823697357:web:686a8b19f579fd1c4d1084"
};